<template>
  <div class="container-body">
    <div class="container-main" v-if="workRegistration">
      <WorkRegistrationForm :workRegistration="workRegistration" :drivers = "drivers" :workDate = "workDate" :workDayEndTime = "workDayEndTime"/>
    </div>
  </div>
</template>
<script>
import WorkRegistrationService from "../services/WorkRegistrationService";
import WorkRegistrationForm from "../components/WorkRegistrationForm";

export default {
  name: "EditWorkRegistration",
  workRegistrationId: null,
  workRegistrationService: null,
  components: {
    WorkRegistrationForm
  },
  data() {
    return {
      workRegistration: null,
      drivers: null,
      workDate: null,
      workDayEndTime: null
    };
  },
  created() {    
    this.workRegistrationService = new WorkRegistrationService();
    this.workRegistrationId = +this.$route.query.workRegistrationId;
    this.drivers = this.$route.query.workday.drivers;
    this.workDate = this.$route.query.workDate;
    this.workDayEndTime = this.$route.query.workDayEndTime;
  },
  mounted() {
    this.getWorkRegistration();
  },
  methods: {
    getWorkRegistration() {
      this.workRegistrationService
        .getWorkRegistration(this.workRegistrationId)
        .then(response => {
          this.workRegistration = response.data;
        });
    }
  }
};
</script>
